import { PaginatedRole } from '../../../models';

export const rolesInitialFilters: Omit<
  PaginatedRole,
  'page' | 'status' | 'name' | 'size' | 'basicInfoId'
> = {
  reportToID: undefined,
};
